export function addPrefetchIFrameToDocument(url: string) {
    const iframeElement = document.createElement('iframe');
    iframeElement.setAttribute('src', url);
    iframeElement.setAttribute(
        'style',
        'visibility:hidden; position:absolute; width:0px; height:0px; left:0px; top 0px;'
    );

    document.body.appendChild(iframeElement);
}
